import { Injectable } from '@angular/core';
import { HandlerService } from './handler.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PdfService } from './pdf.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  lang = localStorage.getItem('lang')
  
  constructor(private http: HttpClient,
    private handler: HandlerService,
    private router: Router,
    private pdf:PdfService) {
    if (this.loged()) {
      this.getUser()
    }
  }
  loged() {
    return !!localStorage.getItem('capabilityOrg');
  }


   
  getCapabilityArn(id,arn) {
    return this.http.get(window['url'] + '/newyess/users/' + id + '/capabilities?endpointArn='+arn);
  }

  getUser() {
    this.http.get(window['url'] + '/newyess/users/' + localStorage.getItem('currentUserId'))
      .subscribe(
        (res: any) => {
          this.handler.user = res
                 },
        err => this.handler.err(err)
      )
      this.getConfig();
  }
  getOrgCapabilities(id,code){
    let check: boolean = false;
    let cap=JSON.parse(localStorage.getItem('capabilityOrg'));
    let getOrg=cap.filter(res=>{ return res.id==id})
    let capabilities = getOrg[0].capabilities.map(({ code }) => code);
    if (capabilities) {
      capabilities.find(res => {
        if (res == code) {
          check = true
        }
      })
    }
    return check;
   }
  async getConfig() {
    let config = await this.http.get(window['url'] + '/newyess/appConfigs').toPromise();
    let x: any = config;
    x = x.map(res => { return res.configs });
    let a: any = [];
    x = x.map(res => { a = a.concat(res) });
    localStorage.setItem('config', JSON.stringify(a))
  }
  login(credentials) {
    return this.http.post(window['url'] + '/userManagement/login/authenticate', credentials);
  }
  LogOut(post){
    return this.http.post(window['url'] + '/userManagement/login/logout',post);   
  }
  getCapability(id) {
    return this.http.get(window['url'] + '/newyess/users/' + id + '/capabilities');
  }
  checkCapability(data1) {
    let check: boolean = false;
    var data = JSON.parse(localStorage.getItem('capability'));
    if (data) {
      data.find(res => {
        if (res == data1) {
          check = true
        }
      })
    }
    return check;
  }

  getOrg(){
    this.http.get(window['url'] + '/newyess/org?franchisorId=' + localStorage.getItem('organizationId'))
      .subscribe(
        (res: any) => {
          localStorage.setItem('orgs',JSON.stringify(res))
                 },
        err => this.handler.err(err)
      )
  }

  getDateformat() {
    if (localStorage.getItem('config')) {
      var con = JSON.parse(localStorage.getItem('config'));
      let y = con.find(res => res.shortCdConst == "DTFMT");
      return y.userValue;
    }
  }
  getMobileLength(){
    if(localStorage.getItem('config')){
    var con = JSON.parse(localStorage.getItem('config'));
    let y = con.find(res => res.shortCdConst == "MOBLNTH");
    return y.userValue;
    }
  }
}
